import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAi = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 500 500",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 320.122H111.888V500H0V320.122Z",
			fill: "#015A78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M129.371 222.561H241.259V500H129.371V222.561Z",
			fill: "#5FDEBD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M258.741 106.707H370.629V500H258.741V106.707Z",
			fill: "#6EB319"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M388.112 0H500V500H388.112V0Z",
			fill: "#D9B500"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 227,
			y: 290,
			width: 273,
			height: 210,
			rx: 15,
			fill: "#2C2A2A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M342.696 443L338.52 422.408H314.76L310.728 443H292.296C296.52 425.432 300.792 409.448 305.112 395.048C309.432 380.552 313.608 366.824 317.64 353.864H336.936C341.16 366.92 345.336 380.792 349.464 395.48C353.688 410.072 357.768 425.912 361.704 443H342.696ZM326.856 371.144C325.896 374.504 324.984 377.72 324.12 380.792C323.352 383.768 322.584 386.744 321.816 389.72C321.144 392.6 320.472 395.528 319.8 398.504C319.224 401.48 318.648 404.552 318.072 407.72H335.496C334.92 404.552 334.344 401.48 333.768 398.504C333.192 395.528 332.52 392.6 331.752 389.72C331.08 386.744 330.312 383.768 329.448 380.792C328.68 377.72 327.816 374.504 326.856 371.144ZM370.776 443V428.312H390.216V368.552H370.776V353.864H427.368V368.552H408.072V428.312H427.368V443H370.776Z",
			fill: "white"
		})
	]
});
export default SvgAi;
